import { SvgIcon } from '@mui/material';
import { BooleanOperation } from '~/engine/util/algorithms/sdf/SDFOperations';
import { ICON_PX } from '~/theme/iconSizes';

// On a 16-unit grid, square A spans 1 to 11 and square B 5 to 15. Outlines
// run on half units so a 1-unit stroke lands on whole pixels at 16 px. The
// filled regions follow the squares' outer edges.
const ONLY_A =
    'M2.5 1H9.5A1.5 1.5 0 0 1 11 2.5V5H6.5A1.5 1.5 0 0 0 5 6.5V11H2.5A1.5 1.5 0 0 1 1 9.5V2.5A1.5 1.5 0 0 1 2.5 1Z';
const ONLY_B =
    'M11 5H13.5A1.5 1.5 0 0 1 15 6.5V13.5A1.5 1.5 0 0 1 13.5 15H6.5A1.5 1.5 0 0 1 5 13.5V11H9.5A1.5 1.5 0 0 0 11 9.5Z';
const BOTH = 'M5 6.5A1.5 1.5 0 0 1 6.5 5H11V9.5A1.5 1.5 0 0 1 9.5 11H5Z';
const EITHER =
    'M2.5 1H9.5A1.5 1.5 0 0 1 11 2.5V5H13.5A1.5 1.5 0 0 1 15 6.5V13.5A1.5 1.5 0 0 1 13.5 15H6.5A1.5 1.5 0 0 1 5 13.5V11H2.5A1.5 1.5 0 0 1 1 9.5V2.5A1.5 1.5 0 0 1 2.5 1Z';

/** The outline of the square whose top-left corner sits at `at`. */
function Outline({ at }: { at: number }) {
    return (
        <rect
            x={at + 0.5}
            y={at + 0.5}
            width={9}
            height={9}
            rx={1}
            fill="none"
            stroke="currentColor"
        />
    );
}

const GLYPHS: Record<BooleanOperation, JSX.Element> = {
    [BooleanOperation.OR]: <path d={EITHER} />,
    [BooleanOperation.AND_NOT]: (
        <>
            <path d={ONLY_A} />
            <Outline at={5} />
        </>
    ),
    [BooleanOperation.AND]: (
        <>
            <Outline at={1} />
            <Outline at={5} />
            <path d={BOTH} />
        </>
    ),
    [BooleanOperation.XOR]: <path d={`${ONLY_A}${ONLY_B}`} />,
};

/**
 * Two overlapping squares, A at the top left and B at the bottom right,
 * with the region the operation keeps filled, in the primary colour.
 */
export default function OperationIcon({
    operation,
}: {
    operation: BooleanOperation;
}) {
    return (
        <SvgIcon viewBox="0 0 16 16" color="primary" sx={{ fontSize: ICON_PX }}>
            {GLYPHS[operation]}
        </SvgIcon>
    );
}
